import Expander from 'components/utils/Expander'
import NavBarContactsItems from 'components/NavKit/NavBarButtons/NavBarContactsItems'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import NavBarListItemIcon from 'components/NavKit/NavBarListItemIcon'
import GeoContext from 'contexts/geoContext'
import useToggle from 'hooks/useToggle'
import shouldRenderTimely from 'lib/timely/timely'
import LineAngleDownBIcon from 'LuxKit/Icons/line/LineAngleDownBIcon'
import LineAngleUpBIcon from 'LuxKit/Icons/line/LineAngleUpBIcon'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import LineWhatsappIcon from 'LuxKit/Icons/line/LineWhatsappIcon'
import { useWhatsAppChannelUrl } from 'hooks/useWhatsAppChannelUrl'
import { rem } from 'polished'
import { useContext } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const ContactListItem = styled(ClickableListItem)`
  padding: ${rem(8)};
`

interface Props {
  onItemClick: () => void
}

function NavBarHamburgerMenuContactsAccordion(props: Props) {
  const { onItemClick } = props
  const intl = useIntl()
  const [expanded, toggleExpanded] = useToggle()
  const { currentRegionCode } = useContext(GeoContext)
  const whatsAppChannelUrl = useWhatsAppChannelUrl()

  const contactOrVisitTitle = intl.formatMessage({
    id: 'b22MFRDZjlNBiR6HNsYh',
    defaultMessage: 'Contact or visit us',
    description:
      'Summary row title for the expandable contact section in the navigation hamburger menu, shown before detailed support options.',
  })
  const contactUsOnlyTitle = intl.formatMessage({
    id: '40bVsRMvxubQsEdLc7Cw',
    defaultMessage: 'Contact us',
    description: 'Contact us button text for tablet and below in the support area',
  })
  const summaryTitle = shouldRenderTimely(currentRegionCode) ? contactOrVisitTitle : contactUsOnlyTitle

  const summarySubtitle = intl.formatMessage({
    id: 'VJsd-xJLC1JE0iwO2pfO',
    defaultMessage: 'Luxury Escapes support',
    description:
      'Summary row subtitle under the contact heading in the navigation hamburger menu, indicating support is from Luxury Escapes.',
  })
  const whatsAppTitle = intl.formatMessage({
    id: '8lpL-8gsl-GQsu8PGO5P',
    defaultMessage: 'WhatsApp',
    description: 'WhatsApp contact title in navigation bar in the support area',
  })

  return (
    <div>
      <ContactListItem
        size="medium"
        onClick={toggleExpanded}
        title={summaryTitle}
        subtitle={summarySubtitle}
        startIcon={<NavBarListItemIcon Icon={LinePhoneIcon} />}
        endIcon={expanded
          ? <LineAngleUpBIcon />
          : <LineAngleDownBIcon />}
      />
      <Expander expanded={expanded}>
        <NavBarContactsItems onItemClick={onItemClick} />
        {whatsAppChannelUrl && <ContactListItem
          size="medium"
          title={whatsAppTitle}
          startIcon={<NavBarListItemIcon Icon={LineWhatsappIcon} />}
          onClick={onItemClick}
          href={whatsAppChannelUrl}
          target="_blank"
          rel="noopener"
        />}
      </Expander>
    </div>
  )
}

export default NavBarHamburgerMenuContactsAccordion
